<template>
  <div class="privacy-video">
    <iframe v-if="enabled" :src="safeSrc" :title="title" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>
    <div v-else class="privacy-video-prompt">
      <strong>{{ title || 'Video z YouTube' }}</strong>
      <p>Po načítaní sa pripojíte k YouTube (Google), ktorý získa údaje o vašom zariadení a môže používať vlastné úložisko.</p>
      <button type="button" @click="enabled = true">Súhlasím a načítať video</button>
      <a href="/ochrana-osobnych-udajov/#cookies">Podrobnosti o súkromí</a>
    </div>
  </div>
</template>
<script setup>
import {ref, computed} from 'vue';
const props = defineProps({src: String, title: String});
const enabled = ref(false);
const safeSrc = computed(() => props.src?.replace('www.youtube.com/', 'www.youtube-nocookie.com/'));
</script>
<style scoped>
.privacy-video {position:relative;min-height:300px;background:#202320;color:#f5f4ee;border-radius:12px;overflow:hidden;}
.privacy-video iframe {position:absolute;inset:0;width:100%;height:100%;border:0;}
.privacy-video-prompt {display:flex;flex-direction:column;align-items:center;justify-content:center;padding:28px;min-height:300px;text-align:center;font:14px/1.5 Inter,Arial,sans-serif;}
.privacy-video-prompt p {max-width:480px;color:#ddd;font-size:14px;}
.privacy-video-prompt button {padding:12px 18px;border:1px solid #b9db81;border-radius:6px;background:#b9db81;color:#171a17;cursor:pointer;font:600 14px Inter,Arial,sans-serif;}
.privacy-video-prompt a {font-size:12px;color:#ddd;margin-top:12px;text-decoration:underline;}
</style>
